import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Button } from '@winelidays/wld-tsx-2/elements';
import { Modal, ModalContent, ModalHeader } from '@winelidays/wld-tsx-2/modules';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import { useState } from 'react';
import SegmentationTable from './SegmentationTable';
const Segmentation = t0 => {
    const $ = _c(19);
    const { segmentation, ageRange } = t0;
    const translate = useTranslate();
    const [isOpen, setIsOpen] = useState(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = () => {
            setIsOpen(true);
        };
        $[0] = t1;
    }
    else {
        t1 = $[0];
    }
    const handleOpenModal = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = () => {
            setIsOpen(false);
        };
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const handleCloseModal = t2;
    const title = `${capitalize(translate("practical.prices.label"))} ${translate("practical.age_range", {
        ...ageRange,
        long: false
    })}`;
    const dialogLabel = `Segmentation ${title}`;
    let t3;
    if ($[2] !== translate) {
        t3 = translate("messages.more_info");
        $[2] = translate;
        $[3] = t3;
    }
    else {
        t3 = $[3];
    }
    const moreInfoButton = t3;
    let t4;
    if ($[4] !== title) {
        t4 = <ModalHeader title={title}/>;
        $[4] = title;
        $[5] = t4;
    }
    else {
        t4 = $[5];
    }
    let t5;
    if ($[6] !== segmentation) {
        t5 = <ModalContent><SegmentationTable segmentation={segmentation}/></ModalContent>;
        $[6] = segmentation;
        $[7] = t5;
    }
    else {
        t5 = $[7];
    }
    let t6;
    if ($[8] !== dialogLabel || $[9] !== isOpen || $[10] !== t4 || $[11] !== t5 || $[12] !== translate) {
        t6 = <Modal isOpen={isOpen} onClose={handleCloseModal} dialogLabel={dialogLabel} hasStandardHeader={true} className="xs:!w-168 sm:h-144" translate={translate} isClient={true}>{t4}{t5}</Modal>;
        $[8] = dialogLabel;
        $[9] = isOpen;
        $[10] = t4;
        $[11] = t5;
        $[12] = translate;
        $[13] = t6;
    }
    else {
        t6 = $[13];
    }
    let t7;
    if ($[14] !== moreInfoButton) {
        t7 = <Button title={moreInfoButton} className="btn-ghost-primary align-baseline text-xs -ml-2" onClick={handleOpenModal}>{moreInfoButton}</Button>;
        $[14] = moreInfoButton;
        $[15] = t7;
    }
    else {
        t7 = $[15];
    }
    let t8;
    if ($[16] !== t6 || $[17] !== t7) {
        t8 = <>{t6}{t7}</>;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    }
    else {
        t8 = $[18];
    }
    return t8;
};
export default Segmentation;
